import { GlobalResponseObject } from "../../global-response-object";
import { DrrDetails } from "./drr-details";


export class DrrDetailsResponse extends GlobalResponseObject{
data?:DrrDetails;
constructor(status: boolean, intlCode: number, internalMessage: string, data?:DrrDetails){
    super(status,intlCode,internalMessage)
    this.data = data;
}
}